import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import routes from 'const/routes'

const useOpenStatementsMFE = () => {
  const navigate = useNavigate()

  return useCallback(() => {
    navigate(routes.STATEMENTS)
  }, [navigate])
}

export default useOpenStatementsMFE
